import e from"../toDate/index.js";import r from"../_lib/requiredArgs/index.js";function t(t,i){r(2,arguments);var o=e(t),m=e(i);return o.getTime()>m.getTime()}export{t as default};
